var _a;

import facepaint from 'facepaint';
import { COLORS, BORDER_RADIUS, GRID } from '../../constants';
import { zIndexLevels } from '../../internalConstants';
export var modalSizes = {
  small: 392,
  "default": 576,
  large: 760,
  'x-large': 1024
};
var breakpoints = [465];
export var mediaQueries = facepaint(breakpoints.map(function (bp) {
  return "@media(min-width: " + bp + "px)";
}));
export var backdropStyles = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: 'rgba(0, 0, 0, 0.45)',
  zIndex: zIndexLevels.modalBackdrop,
  willChange: 'opacity'
};
export var modalStyles = {
  width: '100%',
  left: '50%',
  maxHeight: '100vh',
  background: COLORS.white,
  zIndex: zIndexLevels.modalContent,
  borderRadius: BORDER_RADIUS.large,
  top: '50%',
  transform: 'translate(-50%, -50%)'
};
export var modalAnimationVariants = {
  hidden: {
    opacity: 0,
    x: '-50%',
    y: '-100%'
  },
  visible: {
    opacity: 1,
    x: '-50%',
    y: '-50%'
  }
};
export var backdropAnimationVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1
  }
};
export var contentStyles = {
  boxSizing: 'border-box',
  display: 'block',
  overflowY: 'auto'
};
export var footerStyles = {
  boxSizing: 'border-box',
  display: 'flex',
  flexShrink: 0,
  width: '100%',
  background: COLORS.grays.background,
  borderTop: "solid 1px " + COLORS.grays.cardBorder,
  borderBottomLeftRadius: BORDER_RADIUS.large,
  borderBottomRightRadius: BORDER_RADIUS.large,
  padding: GRID.small + " " + GRID.large,
  '& > *:not(:first-of-type)': {
    marginLeft: GRID.small
  }
};
export var closeButtonStyles = (_a = {
  background: 'none',
  padding: 0,
  margin: 0,
  marginLeft: 8,
  border: "2px solid transparent",
  lineHeight: '16px',
  '&:hover, &:focus': {
    background: 'none',
    outline: 'none'
  }
}, _a["&[data-focus-visible]"] = {
  background: 'none',
  padding: 0,
  margin: 0,
  borderRadius: BORDER_RADIUS.small,
  outline: 'none',
  border: "2px solid " + COLORS.blues.lightest
}, _a);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Modal/styles.js
// module id = 230
// module chunks = 0